firebird.controller('e2eeKeyWasNotProvidedCtrl', [
    'meetingService',
    function (meetingService) {
        var self = this;
        self.getAppLogoURL = meetingService.getAppLogoURL;
    }
]);
